export function isWebview() {
  if (/WhenIWork-webview/g.test(window.navigator.userAgent)) {
    return true;
  }

  return false;
}
